import { Price } from 'data-layer/src/entity/Price';
import { ProductVariant } from 'data-layer/src/entity/ProductVariant';

export const getProductVariantPrices = (variant: ProductVariant) => {
  // use variant prices only when there is real value for priceWithout.
  // In other case fallback to product pricing.
  const variantPrices = (variant.prices || []).filter((p: Price) => p.priceWithout);

  const prices = variantPrices;

  return prices;
};


// WEBPACK FOOTER //
// ../helpers/src/prices/getProductVariantPrices.ts